Vue.component('reset-password', require('./../components/auth/passwords/index.vue').default);
Vue.component('reset-methods', require('./../components/auth/passwords/methods.vue').default);
Vue.component('reset-sent', require('./../components/auth/passwords/sent.vue').default);
Vue.component('reset-newpass', require('./../components/auth/passwords/reset.vue').default);
